import { render, staticRenderFns } from "./addVehicleBusRoute.vue?vue&type=template&id=7672e31d"
import script from "./addVehicleBusRoute.vue?vue&type=script&lang=js"
export * from "./addVehicleBusRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports